<template>
	<Modals title="Object Details" :display="true" @show="$emit('close')">
		<template #modal-content>
			<pre class="object-details__code">
        <code data-test="objectDetails">
					{{ JSON.stringify(objectDetails, null, " ") }}
				</code>
      </pre>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';

export default {
	name: 'LogHistoryObjDetailsModal',
	components: {
		Modals
	},
	props: {
		objectDetails: {
			type: Object,
			default: () => {},
			require: true
		}
	}
};
</script>

<style lang="scss" scoped>
.object-details__code {
	white-space: pre-line;
}
</style>
